import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=f949072e&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f949072e')) {
      api.createRecord('f949072e', component.options)
    } else {
      api.reload('f949072e', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=f949072e&", function () {
      api.rerender('f949072e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ItzJVaOR4L5i/JS/comp/IncreaseNumber.vue"
export default component.exports